import React from "react";
import { Panel } from "components/panels";
import { UserAvatar } from "components/Atoms/Avatar";
import moment from "moment";
import { formatWrittenDateTimeUtc } from "utilities";
import LinkedShowLines from "components/LinkedShows/LinkedShowElement";
import { useCustomQuery, useManualPagination } from "utilities/hookutils";
import { ShowSidePanel } from "components/SidePanel/Show/ShowSidePanel";
import { AppointmentPhase } from "components";
import { PhosphorWarning } from "components/Atoms/PhosphorIcon";

interface Props {
  config: server.dto.DashboardExternalInputPanelConfig
}

const queryKey = "showsFromExternalInput";

const ExternalShowsPanel = (props: Props) => {
  const perPage = 10;
  const pagination = useManualPagination(1, perPage, () => { });

  const query = useCustomQuery({
    queryFn: async () => window.CoreApi.Dashboard.ShowsFromExternalInput(pagination.page, perPage, { toastOnError: true }).then(r => r.data),
    queryKey: [queryKey, {
      page: pagination.page,
      perPage
    }],
    keepPreviousData: true,
    onSuccess: (data) => { pagination.setPagination(data.pagination); }
  });

  return (
    <Panel
      title={props.config.headerLabel}
      panelClassName="s1_dashboard-panel"
      pagination={pagination.Component}
      hasError={query.isError}
      isLoading={query.isLoading}
      hasData={query.data?.data.length > 0}
    >
      <div className="list-with-gaps line-layout">
        <div className="list-with-gaps-body">
          {query.data?.data.map((item) => {
            const createdMoment = moment.utc(item.createdUtc);
            return (
              <div className="radius hoverable" key={item.showId}>
                <ShowSidePanel
                  key={item.showId}
                  canEdit={false}
                  trigger={
                    <>
                      <div>
                        <UserAvatar user={item.createdBy} />
                      </div>
                      <div style={{ flex: "0 0 30%" }} title={formatWrittenDateTimeUtc(createdMoment)}>
                        <div>{item.createdBy.fullName}</div>
                        <div className="text-sublabel">{createdMoment.fromNow()}</div>
                      </div>
                      <div>
                        <AppointmentPhase value={item.status.appointmentPhase} displayLabel={false} />
                      </div>
                      <div style={{ flex: "1" }}>
                        <LinkedShowLines
                          dateTime={item.dateTime}
                          eventDescription={item.eventDescription}
                          format="big" />
                      </div>
                      <div style={{ flex: "0 0 16px" }}>
                        <PhosphorWarning iconSize="large" />
                      </div>
                    </>
                  }
                  showId={item.showId}
                />
              </div>
            );
          })}
        </div>
      </div>
    </Panel>
  );
};

export default ExternalShowsPanel;
